import { ChangeDetectorRef, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { RoutingService, TranslationService, TranslatePipe } from '@spartacus/core';
import { Observable, Subscription, combineLatest } from 'rxjs';
import { KnBrOrderReturn } from '../../../models/kn-br-order.model';
import { KnBrOrderReturnService } from '../../../store/kn-br-order-return/kn-br-order-return.service';
import { KnBrCustomerContextService } from '../../../store/kn-br-customer-context/kn-br-customer-context.service';
import { map } from 'rxjs/operators';
import * as _ from 'lodash';
import { CustomerData } from '../../../models/customer.model';
import { KnBrCommonService } from 'src/app/services/kn-br-common.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ViewportScroller, NgIf, NgFor, AsyncPipe } from '@angular/common';
import { KnBrBrowsingComponent } from '../../../common/kn-br-browsing/kn-br-browsing.component';
import { SortingComponent } from '@spartacus/storefront';
import { RemoveLeadingZerosPipe } from '../../../shared/pipe/kn-br-custom-pipes/remove-leading-zeros.pipe';

@Component({
    selector: 'knbr-kn-br-return-order-search-result',
    templateUrl: './kn-br-return-order-search-result.component.html',
    styleUrls: ['./kn-br-return-order-search-result.component.scss'],
    imports: [ KnBrBrowsingComponent, SortingComponent, AsyncPipe, TranslatePipe, RemoveLeadingZerosPipe]
})
export class KnBrReturnOrderSearchResultComponent implements OnInit, OnDestroy {
  orderReturnListResult$: Observable<KnBrOrderReturn[]> = this.knBrOrderReturnService.list$;
  isLoader$: Observable<boolean> = this.knBrOrderReturnService.loader$;
  paginate$: Observable<any> = this.knBrOrderReturnService.paginate$;
  sorts$: Observable<any> = this.knBrOrderReturnService.sorts$;
  searchCriteria: any;
  sortType: string;
  subscription: Subscription;
  downloadProgress = false;
  modalRef: any;
  ViewportScroller = inject(ViewportScroller);

  constructor(
    public knBrOrderReturnService: KnBrOrderReturnService,
    protected routeService: RoutingService,
    protected knBrCustomerContextService: KnBrCustomerContextService,
    protected translation: TranslationService,
    protected knBrCommonService: KnBrCommonService,
    protected cdRef?: ChangeDetectorRef,
    protected modalService?: NgbModal
  ) { }

  ngOnInit(): void {
    this.ViewportScroller.scrollToPosition([0, 0]);
    this.subscription = this.knBrOrderReturnService.searchCriteria$.subscribe((response) => {
      this.searchCriteria = _.cloneDeep(response);
    });
    this.subscription.add(
      this.paginate$.subscribe((paginate: any) => {
        if (paginate) {
          this.sortType = paginate.sort;
        }
      })
    );
    this.subscription.add(this.knBrOrderReturnService.loader$.subscribe({
      next: response => {
        this.knBrCommonService.setSpinner(response)
      },
      error: error => { }
    }))
  }

  getSortLabels(): Observable<{ byDate: string; byRMA: string; byPONumber: string; byStatus: string }> {
    return combineLatest([
      this.translation.translate('sorting.date'),
      this.translation.translate('sorting.rma'),
      this.translation.translate('sorting.poNumber'),
      this.translation.translate('sorting.status'),
    ]).pipe(
      map(([textByDate, textByRMA, textByPoNumber, textByStatus]) => {
        return {
          byDate: textByDate,
          byRMA: textByRMA,
          byPONumber: textByPoNumber,
          byStatus: textByStatus,
        };
      })
    );
  }

  changeSortCode(sortCode: string): void {
    if (this.searchCriteria) {
      this.searchCriteria.currentPage = 0;
      this.searchCriteria.sort = sortCode;
    }
    this.sortType = sortCode;
    this.knBrOrderReturnService.returnOrderListSearch(this.searchCriteria);
  }

  loadMore(currentPage: number) {
    if (this.searchCriteria) {
      this.searchCriteria.currentPage = currentPage + 1;
      this.searchCriteria.sort = this.sortType;
    }
    this.knBrOrderReturnService.returnOrderListSearch(this.searchCriteria);
  }

  redirectToDetail(order: KnBrOrderReturn) {
    const customerContext: CustomerData = {
      customerNumber: order.accountNumber,
      customerName: order.accountName,
      city: order.city
    };
    //this.knBrCustomerContextService.set(customerContext);
    this.routeService.go({ cxRoute: 'returnRequestDetails', params: order });
  }

  downloadReturns(param1, param2, downloadFlag, fileName) {
    if (downloadFlag) {
      const data = {
        param1: param1,
        param2: param2,
        searchCriteria: this.searchCriteria,
        startDownload: true,
        fileName: fileName,
        displayName: 'Returns'
      }
      this.knBrCommonService.downloadItems(data)
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
